import { DateTimeProvider } from 'angular-oauth2-oidc';
import { Injectable } from '@angular/core';

@Injectable()
export class ServerDateTimeService extends DateTimeProvider {

    static readonly TIME_DIFF_LIMIT = 50000;
    static readonly DEFAULT_TIME_DIFF = 0;
    static timeOffset = ServerDateTimeService.DEFAULT_TIME_DIFF;

    constructor() {
        super();
        this.initTimeOffset();
    }

    override now() {
        return Date.now() - ServerDateTimeService.timeOffset;
    }

    override new() {
        return new Date(Date.now() - ServerDateTimeService.timeOffset);
    }

    private initTimeOffset() {
        fetch('/api/start/serverdatetime')
            .then(res => res.json())
            .then(respJson => respJson.unixTimestampMs)
            .then(serverTimestamp => {
                const timeOffset = Date.now() - serverTimestamp;
                ServerDateTimeService.timeOffset = Math.abs(timeOffset) >= ServerDateTimeService.TIME_DIFF_LIMIT
                    ? timeOffset
                    : ServerDateTimeService.DEFAULT_TIME_DIFF;
            });
    }
}
